// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__pELXh","user_container":"Dashboard_user_container__V+wB9"};